import type { IconProps } from '../types/IconProps.ts';
export const Truck: IconProps = {
    name: 'Truck',
    children: [
        `<circle cx="7" cy="18" r="2" />`,
        `<circle cx="17" cy="18" r="2" />`,
        `<path d="M5 18H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12M9 18h6M19 18h1a2 2 0 0 0 2-2v-3.54a2 2 0 0 0-.65-1.47l-3.78-3.46A2 2 0 0 0 16.22 7H14" />`,
    ]
};